import Vue from 'vue/dist/vue.esm'

Vue.component("forms-filters-tree-vue",  () => import(/* webpackChunkName: "[request]" */ "components/forms/FiltersTree.vue"))
